import React from "react";
import Typography from "@material-ui/core/Typography";
import { controlRespaldoResources } from "../endpoints";
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from "@material-ui/icons/Check";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import DialogPlanificarRespaldo from "../components/DialogPlanificarRespaldo";
import SnackbarAlert from "../components/SnackbarAlert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogEliminar from "../components/DialogEliminar";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

class ControlRespaldos extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            cargando: true,
            datos: [],
            totalFilas: 0,
            paginationModel: { page: 0, pageSize: 50 },
            searchQuery: "",
            sortModel: [],
            openDialog: false,
            openSnack: false,
            severity: '',
            message: '',
            rowData: null,
            openEliminar: false,
        }
    }

    handlePaginationModelChange = (newModel) => {
        this.setState({ paginationModel: newModel }, () => {
            this.cargarDatos();
        });
    }

    handleSortModelChange = (newSortModel) => {
        this.setState({ sortModel: newSortModel }, () => {
            this.cargarDatos();
        });
    }

    handleOpenDialog = () => {
        this.setState({ openDialog: true });
    }

    handleCloseDialog = () => {
        this.setState({ openDialog: false , openEliminar: false});
    }

    handleSearchChange = (event) => {
        const valor = event.target.value;
        this.setState({ searchQuery: valor });

        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.setState({ paginationModel: { ...this.state.paginationModel, page: 0 } }, () => {
                this.cargarDatos();
            });
        }, 600);
    }

    cargarDatos = () => {
        this.setState({ cargando: true});
        
        const { page, pageSize } = this.state.paginationModel;
        const { searchQuery, sortModel } = this.state;
        
        let sortField = null;
        let sortDir = "desc"; 
        
        if (sortModel.length > 0) {
            sortField = sortModel[0].field;
            sortDir = sortModel[0].sort;
        }

        controlRespaldoResources.getControlRespaldos(page, pageSize, searchQuery, sortField, sortDir)
            .then(async response => {
                if (response) return await response.json();
            })
            .then(result => {
                if (result.status_code === 200) {
                    this.setState({ 
                        cargando: false, 
                        datos: result.respaldos,
                        totalFilas: result.total 
                    });
                    
                } else {
                    throw new Error('Something went wrong ...');
                }
            })
            .catch(error => {
                console.error(error);
                this.setState({ cargando: false });
            });
    }
    
    eliminarControlRespaldo = (rowData) => {
        this.setState({openEliminar: true, id:rowData.id, title: "Eliminar control de respaldo",content: "Está seguro que desea eliminar el control de respaldo?", openSnack:false})
    }

    componentDidMount(){
        this.cargarDatos();
    }

    refrescar=(estado,severity)=>{
       this.setState({
            openSnack: false
        }, () => {
            this.setState({openSnack:false, severity:null, message:null})
            if(estado){
                this.setState({
                    openDialog:false,
                    openEliminar:false,
                    openSnack: true,
                    message: estado,
                    severity: severity}, () => {
                        this.cargarDatos();
                    });
            }
        });
    }

    editarTipoJornada = (idControlRespaldos, nuevoTipoJornada) => {
        controlRespaldoResources.editarTipoJornada(idControlRespaldos, nuevoTipoJornada)
            .then(async response => {
                const data = await response.json();
                if (response.ok) {
                    this.refrescar(data.message, data.severity);
                } else {
                    this.refrescar(data.message || "Error al editar", "error");
                }
            })
            .catch(error => {
                console.error(error);
                this.refrescar("Error de conexión al editar el tipo de jornada", "error");
            });
    }

    render() {
         const columns = [
            { field: "folio", headerName: "Folio", flex: 1, minWidth: 80,},
            { field: "fecha_jornada", headerName: "Fecha", flex: 1, minWidth: 150, },
            { 
                field: "tipo_jornada", 
                headerName: "Tipo jornada", 
                flex: 1, 
                minWidth: 120,
                renderCell: (params) => (
                    <Select
                        value={params.value || ''}
                        size="small"
                        onChange={(e) => this.editarTipoJornada(params.row.id, e.target.value)}
                        sx={{fontSize: "0.90rem", height: 28}}
                    >
                        <MenuItem sx={{fontSize: "0.90rem", height: 28}} value="AM">AM</MenuItem>
                        <MenuItem sx={{fontSize: "0.90rem", height: 28}} value="PM">PM</MenuItem>
                    </Select>
                )
            },
            {
                field: "cliente",
                headerName: "Cliente",
                flex: 1, minWidth: 150,
            },
            {
                field: "tienda",
                headerName: "Tienda",
                flex: 1, minWidth: 300,
               
            },
            {
                field: "respaldado",
                headerName: "Respaldado",
                flex: 1, minWidth: 100,
                sortable: false,
                filterable: false,
                renderCell: (params) => (params.row.respaldado ? <CheckIcon /> : null),
            },
            {
                field: "estado",
                headerName: "Estado",
                flex: 1, minWidth: 90,
                valueFormatter: (params) => params.value?.toUpperCase(),
            },
            { field: "fecha_recepcion_formateada", headerName: "Fecha respaldo", flex: 1, minWidth: 230, },
            { field: "tipo_ingreso", headerName: "Tipo de ingreso", flex: 1, minWidth: 230, },
            {
                field: 'acciones',
                headerName: 'Acciones',
                minWidth: 180,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    const rowData = params.row;

                    return (
                        <Box>
                            <IconButton onClick={() => this.eliminarControlRespaldo(rowData)} disabled={rowData.fecha_recepcion !== null } color="error">
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    );
                }
            }
        ];

        return (
            <div>
                <Typography variant="h4" gutterBottom>Control de Respaldos</Typography>
                
                <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                    <Grid item>
                        <div style={{ maxWidth: 400 }}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder="Buscar..."
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>  
                    </Grid>
                    <Grid item>
                        <Button variant="contained" color="primary" onClick={()=>{this.setState({'openDialog': true, title: 'Planificar respaldos'})}}>
                            Planificar respaldos
                        </Button>
                    </Grid>
                </Grid>
                <div style={{ height: '100%', width: '100%' }}>
                    <DataGrid
                        rows={this.state.datos}
                        columns={columns}
                        loading={this.state.cargando}
                        disableSelectionOnClick
                        density="compact"
                        disableColumnMenu
                        disableColumnFilter
                        pagination
                        paginationMode="server"
                        sortingMode="server" 
                        rowCount={this.state.totalFilas}
                        sortingOrder={['asc', 'desc']}
                        paginationModel={this.state.paginationModel}
                        onPaginationModelChange={this.handlePaginationModelChange}
                        sortModel={this.state.sortModel}
                        onSortModelChange={this.handleSortModelChange}
                        pageSizeOptions={[10, 25, 50, 100]}
                    />
                </div>
                {this.state.openDialog && <DialogPlanificarRespaldo title={this.state.title} handleClose={this.handleCloseDialog} refrescar={this.refrescar}/>}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.openEliminar? <DialogEliminar origen={"ControlRespaldos"} handleClose={this.handleCloseDialog} refrescar={this.refrescar} content={this.state.content} title={this.state.title} id={this.state.id} tipo={this.state.tipo} />:null}
            </div>
        )
    }
}

export default ControlRespaldos;